import React from 'react';
import styled from 'styled-components';

// --- Estilos para el Modal de Recordatorio ---

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 2.5rem;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 480px;
  text-align: center;
  border: 3px solid #FFA726;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from { 
      transform: translateY(-30px);
      opacity: 0;
    }
    to { 
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const ReminderIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

const ModalTitle = styled.h2`
  font-family: ${props => props.theme.typography.titleFamily};
  color: #FFA726;
  margin: 0 0 1.5rem 0;
  font-size: 1.5rem;
  font-weight: 700;
`;

const ModalText = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1rem;
`;

const TimeInfo = styled.div`
  background-color: #FFF3E0;
  border-left: 4px solid #FFA726;
  padding: 1rem 1.5rem;
  border-radius: 4px;
  margin-bottom: 2rem;
  text-align: left;
`;

const TimeText = styled.p`
  color: #F57C00;
  margin: 0;
  font-weight: 600;
  font-size: 0.95rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const ActionButton = styled.button`
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 1rem;
  padding: 1rem 2rem;
  border-radius: ${props => props.theme.borderRadius};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ExportButton = styled(ActionButton)`
  background-color: #4CAF50;
  color: white;
  
  &:hover:not(:disabled) {
    background-color: #45a049;
    transform: translateY(-2px);
  }
`;

const LaterButton = styled(ActionButton)`
  background-color: transparent;
  color: ${props => props.theme.colors.textSecondary};
  border: 2px solid ${props => props.theme.colors.border};
  
  &:hover:not(:disabled) {
    background-color: ${props => props.theme.colors.border};
  }
`;

const ExportReminderModal = ({ isOpen, onExport, onDismiss, currentTime }) => {
  if (!isOpen) return null;

  const formatTime = (date) => {
    return date.toLocaleTimeString('es-AR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  return (
    <ModalBackdrop onClick={onDismiss}>
      <ModalContent className="axon-modal-sheet" onClick={(e) => e.stopPropagation()}>
        <ReminderIcon>📊</ReminderIcon>
        
        <ModalTitle>¡Recordatorio de Exportación!</ModalTitle>
        
        <ModalText>
          Son las <strong>{formatTime(currentTime)}</strong> y es hora de hacer el respaldo diario 
          de las operaciones en Google Drive.
        </ModalText>

        <TimeInfo>
          <TimeText>
            ⏰ Recuerda: El cierre automático se ejecuta a las 21:00 hs
          </TimeText>
          <TimeText>
            💾 Exporta ahora para asegurar el respaldo de toda la información del día
          </TimeText>
        </TimeInfo>

        <ModalText>
          ¿Quieres exportar las operaciones a Google Drive ahora?
        </ModalText>
        
        <ButtonContainer className="axon-modal-actions">
          <ExportButton onClick={onExport}>
            📤 Exportar Ahora
          </ExportButton>
          
          <LaterButton onClick={onDismiss}>
            ⏰ Recordar más tarde
          </LaterButton>
        </ButtonContainer>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default ExportReminderModal;